import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { Job } from '../types/job';

export function useJob(id: string) {
  const [job, setJob] = useState<Job | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchJob = async () => {
    try {
      const { data, error: fetchError } = await supabase
        .from('nrm_jobs')
        .select(`
          *,
          company:company_id (
            id,
            name
          )
        `)
        .eq('id', id)
        .single();

      if (fetchError) throw fetchError;
      setJob(data);
    } catch (err) {
      setError('Failed to load job details');
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJob();
  }, [id]);

  return { job, loading, error, refetch: fetchJob };
}